/**
 * Thin wrapper around localStorage with a clear namespace.
 * Pluggable: swap for Electron safeStorage in a future Electron wrapper.
 */

const PREFIX = "tilt-kiosk.";

export const secureStorage = {
  getItem(key: string): string | null {
    try {
      return localStorage.getItem(PREFIX + key);
    } catch {
      return null;
    }
  },
  setItem(key: string, value: string): void {
    try {
      localStorage.setItem(PREFIX + key, value);
    } catch {
      // Storage quota exceeded or private mode — ignore.
    }
  },
  removeItem(key: string): void {
    try {
      localStorage.removeItem(PREFIX + key);
    } catch {
      // Ignore.
    }
  },
  clear(): void {
    try {
      const keys = Object.keys(localStorage).filter((k) =>
        k.startsWith(PREFIX),
      );
      keys.forEach((k) => localStorage.removeItem(k));
    } catch {
      // Ignore.
    }
  },
};
